import { createVuetify } from "vuetify";

export const vuetify = createVuetify({
  theme: {
    defaultTheme: "otek",
    themes: {
      otek: {
        dark: false,
        colors: {
          primary: "#C41E3A",
          secondary: "#333333",
          background: "#F5F5F5"
        }
      }
    }
  }
});
